import { render, staticRenderFns } from "./ErrorPageContainer.vue?vue&type=template&id=4b0be969&scoped=true&"
import script from "./ErrorPageContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorPageContainer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPageContainer.vue?vue&type=style&index=0&id=4b0be969&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0be969",
  null
  
)

export default component.exports